<section class="ao-block" [ngClass]="{ 'border-0 mb-0': stopTimer }">
  <div class="col-sm-12 text-center">
    <img *scImage="rendering.fields.image" />
    <h1 *scText="rendering.fields.accessTitle"></h1>
    <p *scText="rendering.fields.text"></p>
  </div>
</section>
